import { priceWithDiscount } from './priceWithDiscount';

export const calcPrice = ({ discount, isBoost, priceNEcards, priceMoogold }) => {
  const price = isBoost ? priceNEcards : priceMoogold;

  const totalPrice = discount ? priceWithDiscount(price, discount) : price;
  return totalPrice;
};
